<template>
  <!-- 已绑定创意列表 - 抽屉 -->
  <el-drawer
    v-model="drawerVisible"
    :title="`创意集 - ${currentName}`"
    size="1500px"
    :close-on-click-modal="false"
    @close="close"
  >
    <div class="creative-drawer">
      <div class="creative-drawer__header">
        <span>已绑定 <b>{{ boundList.length }}</b> 个创意</span>
        <div>
          <el-button type="danger" size="small" :disabled="!boundList.length" @click="handleUnbindAll">一键解绑</el-button>
          <el-button type="primary" size="small" @click="openBindDialog">绑定创意</el-button>
        </div>
      </div>

      <el-table
        v-loading="loading"
        :data="boundList"
        border
        size="small"
        class="js-table"
      >
        <el-table-column prop="ideaId" label="ID" width="70" align="center" />
        <el-table-column label="素材" width="100" align="center">
          <template v-slot="{ row }">
            <el-popover
              v-if="parseImgUrls(row.imgUrl).length > 0"
              placement="left-start"
              :width="300"
              trigger="hover"
            >
              <template #reference>
                <el-image
                  :src="resolveUrl(parseImgUrls(row.imgUrl)[0])"
                  style="width: 60px; height: 60px; border-radius: 4px"
                  fit="cover"
                />
              </template>
              <el-image
                v-for="(url, i) in parseImgUrls(row.imgUrl)"
                :key="i"
                :src="resolveUrl(url)"
                style="width: 260px; margin-bottom: 4px"
              />
            </el-popover>
            <div v-else-if="row.videoUrl">
              <video :src="resolveUrl(row.videoUrl)" style="width: 60px; height: 60px; border-radius: 4px; object-fit: cover" />
            </div>
            <span v-else style="color: #909399">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="ideaTitle" label="标题" min-width="130" show-overflow-tooltip />
        <el-table-column prop="appName" label="应用" min-width="100" show-overflow-tooltip />
        <el-table-column label="类型" width="80" align="center">
          <template v-slot="{ row }">
            {{ ideaTypeText(row.ideaType) }}
          </template>
        </el-table-column>
        <el-table-column label="形式" width="70" align="center">
          <template v-slot="{ row }">
            {{ row.ideaStyle === 1 ? '图片' : '视频' }}
          </template>
        </el-table-column>
        <el-table-column label="审核" width="80" align="center">
          <template v-slot="{ row }">
            <el-tag :type="auditStatusTag(row.channelAuditStatus)" size="small">
              {{ auditStatusText(row.channelAuditStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-button @click="handleUnbind(row)" type="text" size="mini" style="color: red">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 绑定创意弹窗 -->
    <el-dialog
      v-model="bindDialogVisible"
      title="绑定创意"
      width="1100px"
      :close-on-click-modal="false"
      @close="closeBindDialog"
      append-to-body
    >
      <div class="bind-creative">
        <div class="bind-creative__header">
          <span>创意集：<b>{{ currentName }}</b></span>
          <span style="margin-left: 20px">已选 <b>{{ selectedIds.length }}</b> 个创意</span>
        </div>

        <div class="bind-creative__search">
          <el-input v-model="queryParams.ideaId" placeholder="创意ID" clearable size="small" style="width: 120px; margin-right: 10px" />
          <el-input v-model="queryParams.bundle" placeholder="应用包名" clearable size="small" style="width: 140px; margin-right: 10px" />
          <el-select v-model="queryParams.ideaType" placeholder="创意类型" clearable size="small" style="width: 120px; margin-right: 10px">
            <el-option label="Banner" :value="1" />
            <el-option label="开屏" :value="2" />
            <el-option label="插屏" :value="3" />
            <el-option label="原生" :value="4" />
            <el-option label="激励视频" :value="5" />
          </el-select>
          <el-select v-model="queryParams.ideaStyle" placeholder="创意形式" clearable size="small" style="width: 110px; margin-right: 10px">
            <el-option label="图片" :value="1" />
            <el-option label="视频" :value="2" />
          </el-select>
          <el-select v-model="queryParams.channelAuditStatus" placeholder="审核状态" clearable size="small" style="width: 110px; margin-right: 10px">
            <el-option label="待审核" :value="0" />
            <el-option label="审核通过" :value="1" />
            <el-option label="审核中" :value="2" />
            <el-option label="驳回" :value="3" />
          </el-select>
          <el-button @click="searchCreatives" type="primary" size="small">查询</el-button>
        </div>

        <el-table
          v-loading="searchLoading"
          :data="creativeList"
          border
          size="small"
          height="500"
          @selection-change="handleSelectionChange"
          :row-key="row => row.ideaId"
          ref="creativeTable"
        >
          <el-table-column type="selection" width="45" align="center" :reserve-selection="true" />
          <el-table-column prop="ideaId" label="ID" width="65" align="center" />
          <el-table-column label="素材" width="100" align="center">
            <template v-slot="{ row }">
              <el-popover
                v-if="parseImgUrls(row.imgUrl).length > 0"
                placement="left-start"
                :width="300"
                trigger="hover"
              >
                <template #reference>
                  <el-image
                    :src="resolveUrl(parseImgUrls(row.imgUrl)[0])"
                    style="width: 50px; height: 50px; border-radius: 4px"
                    fit="cover"
                  />
                </template>
                <el-image
                  v-for="(url, i) in parseImgUrls(row.imgUrl)"
                  :key="i"
                  :src="resolveUrl(url)"
                  style="width: 260px; margin-bottom: 4px"
                />
              </el-popover>
              <div v-else-if="row.videoUrl">
                <video :src="resolveUrl(row.videoUrl)" style="width: 50px; height: 50px; border-radius: 4px; object-fit: cover" />
              </div>
              <span v-else style="color: #909399">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="ideaTitle" label="标题" min-width="130" show-overflow-tooltip />
          <el-table-column prop="appName" label="应用" min-width="100" show-overflow-tooltip />
          <el-table-column label="类型" width="80" align="center">
            <template v-slot="{ row }">
              {{ ideaTypeText(row.ideaType) }}
            </template>
          </el-table-column>
          <el-table-column label="形式" width="70" align="center">
            <template v-slot="{ row }">
              {{ row.ideaStyle === 1 ? '图片' : '视频' }}
            </template>
          </el-table-column>
          <el-table-column label="审核" width="80" align="center">
            <template v-slot="{ row }">
              <el-tag :type="auditStatusTag(row.channelAuditStatus)" size="small">
                {{ auditStatusText(row.channelAuditStatus) }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>

        <div class="bind-creative__pagination">
          <el-pagination
            @size-change="handleBindSizeChange"
            @current-change="handleBindCurrentChange"
            :current-page="bindPagination.pageNum"
            :page-sizes="[10, 20, 50]"
            :page-size="bindPagination.pageSize"
            :total="bindPagination.total"
            background
            layout="total, sizes, prev, pager, next"
            small
          />
        </div>
      </div>

      <template #footer>
        <el-button @click="closeBindDialog" size="medium">取消</el-button>
        <el-button @click="submitBind" type="primary" size="medium" :loading="bindLoading">
          确定绑定（{{ selectedIds.length }}）
        </el-button>
      </template>
    </el-dialog>
  </el-drawer>
</template>

<script>
import { getRtbCreativeList } from '@/api/manage/creative/creative'
import { getCreativeSetById, updateCreativeSet, getCreativeListBySetId } from '@/api/manage/creativeSet/creativeSet'

export default {
  emits: ['submit'],
  data () {
    return {
      // 抽屉
      drawerVisible: false,
      loading: false,
      currentId: null,
      currentName: '',
      currentMediaId: null,
      boundList: [],
      boundIdeaIds: [],

      // 绑定弹窗
      bindDialogVisible: false,
      searchLoading: false,
      bindLoading: false,
      creativeList: [],
      selectedIds: [],
      queryParams: {
        ideaId: '',
        bundle: '',
        ideaType: null,
        ideaStyle: null,
        channelAuditStatus: 1
      },
      bindPagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  methods: {
    // ========== 抽屉 ==========
    async open (row) {
      this.drawerVisible = true
      this.currentId = row.id
      this.currentName = row.setName
      this.currentMediaId = row.mediaId
      await this.loadBoundCreatives()
    },
    close () {
      this.drawerVisible = false
      this.currentId = null
      this.currentName = ''
      this.currentMediaId = null
      this.boundList = []
      this.boundIdeaIds = []
    },
    async loadBoundCreatives () {
      this.loading = true
      try {
        // 获取创意集详情（拿到ideaIds用于解绑/绑定逻辑）
        const setRes = await getCreativeSetById(this.currentId)
        if (setRes && setRes.data && setRes.data.ideaIds) {
          this.boundIdeaIds = setRes.data.ideaIds.split(',').map(id => Number(id)).filter(id => id)
        } else {
          this.boundIdeaIds = []
        }
        // 通过专用接口获取已绑定的创意列表
        const listRes = await getCreativeListBySetId(this.currentId)
        if (listRes && listRes.data) {
          this.boundList = listRes.data || []
        } else {
          this.boundList = []
        }
      } catch (e) {
        console.error('加载已绑定创意失败', e)
        this.boundList = []
      } finally {
        this.loading = false
      }
    },
    async handleUnbind (row) {
      try {
        await this.$confirm(`确定解绑创意 [${row.ideaId}] 吗？`, '解绑确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        return
      }
      const newIds = this.boundIdeaIds.filter(id => id !== row.ideaId)
      try {
        const res = await updateCreativeSet({
          id: this.currentId,
          ideaIds: newIds.length > 0 ? newIds.join(',') : ''
        })
        if (res.code === 200) {
          this.$message.success('解绑成功')
          await this.loadBoundCreatives()
          this.$emit('submit')
        }
      } catch (e) {
        console.error('解绑失败', e)
      }
    },
    async handleUnbindAll () {
      try {
        await this.$confirm(`确定解绑全部 ${this.boundList.length} 个创意吗？此操作将清空该创意集的所有绑定。`, '一键解绑确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        return
      }
      try {
        const res = await updateCreativeSet({
          id: this.currentId,
          ideaIds: ''
        })
        if (res.code === 200) {
          this.$message.success('已全部解绑')
          await this.loadBoundCreatives()
          this.$emit('submit')
        }
      } catch (e) {
        console.error('一键解绑失败', e)
      }
    },

    // ========== 绑定弹窗 ==========
    openBindDialog () {
      this.bindDialogVisible = true
      this.selectedIds = [...this.boundIdeaIds]
      this.searchCreatives()
    },
    closeBindDialog () {
      this.bindDialogVisible = false
      this.creativeList = []
      this.selectedIds = []
      this.queryParams = { ideaId: '', bundle: '', ideaType: null, ideaStyle: null, channelAuditStatus: 1 }
      this.bindPagination = { pageNum: 1, pageSize: 20, total: 0 }
      this.$refs.creativeTable && this.$refs.creativeTable.clearSelection()
    },
    async searchCreatives () {
      this.searchLoading = true
      try {
        const params = {
          pageNum: this.bindPagination.pageNum,
          pageSize: this.bindPagination.pageSize,
          flag: 0,
          mediaId: this.currentMediaId
        }
        if (this.queryParams.ideaId) params.ideaId = this.queryParams.ideaId
        if (this.queryParams.bundle) params.bundle = this.queryParams.bundle
        if (this.queryParams.ideaType !== null && this.queryParams.ideaType !== '') {
          params.ideaType = this.queryParams.ideaType
        }
        if (this.queryParams.ideaStyle !== null && this.queryParams.ideaStyle !== '') {
          params.ideaStyle = this.queryParams.ideaStyle
        }
        if (this.queryParams.channelAuditStatus !== null && this.queryParams.channelAuditStatus !== '') {
          params.channelAuditStatus = this.queryParams.channelAuditStatus
        }
        const res = await getRtbCreativeList(params)
        if (res && res.data) {
          this.creativeList = res.data.records || []
          this.bindPagination.total = res.data.total || 0
          // 回显已选中项
          this.$nextTick(() => {
            if (this.$refs.creativeTable) {
              this.creativeList.forEach(row => {
                if (this.selectedIds.includes(row.ideaId)) {
                  this.$refs.creativeTable.toggleRowSelection(row, true)
                }
              })
            }
          })
        }
      } catch (e) {
        console.error('查询创意列表失败', e)
      } finally {
        this.searchLoading = false
      }
    },
    handleBindSizeChange (size) {
      this.bindPagination.pageSize = size
      this.bindPagination.pageNum = 1
      this.searchCreatives()
    },
    handleBindCurrentChange (page) {
      this.bindPagination.pageNum = page
      this.searchCreatives()
    },
    handleSelectionChange (selection) {
      const currentPageIds = this.creativeList.map(r => r.ideaId)
      const otherPageSelected = this.selectedIds.filter(id => !currentPageIds.includes(id))
      this.selectedIds = [...otherPageSelected, ...selection.map(r => r.ideaId)]
    },
    async submitBind () {
      if (this.selectedIds.length === 0) {
        this.$message.warning('请至少选择一个创意')
        return
      }
      this.bindLoading = true
      try {
        const res = await updateCreativeSet({
          id: this.currentId,
          ideaIds: this.selectedIds.join(',')
        })
        if (res.code === 200) {
          this.$message.success('绑定成功')
          this.closeBindDialog()
          await this.loadBoundCreatives()
          this.$emit('submit')
        }
      } catch (e) {
        console.error('绑定创意失败', e)
      } finally {
        this.bindLoading = false
      }
    },

    // ========== 工具方法 ==========
    parseImgUrls (imgUrl) {
      if (!imgUrl) return []
      if (Array.isArray(imgUrl)) return imgUrl.filter(url => typeof url === 'string' && url.trim())
      try {
        const parsed = JSON.parse(imgUrl)
        if (Array.isArray(parsed)) return parsed.filter(url => typeof url === 'string' && url.trim())
      } catch (e) {}
      return imgUrl.split(',').map(url => url.trim().replace(/^\[?["']?|["']?\]?$/g, '')).filter(url => url)
    },
    resolveUrl (url) {
      if (!url) return ''
      return url.indexOf('http') === 0 ? url : this.$imgURL + url
    },
    ideaTypeText (type) {
      const map = { 1: 'Banner', 2: '开屏', 3: '插屏', 4: '原生', 5: '激励视频' }
      return map[type] || '-'
    },
    auditStatusText (status) {
      const map = { 0: '待审核', 1: '通过', 2: '审核中', 3: '驳回' }
      return map[status] || '未知'
    },
    auditStatusTag (status) {
      const map = { 0: 'info', 1: 'success', 2: 'warning', 3: 'danger' }
      return map[status] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.creative-drawer {
  padding: 0 16px 16px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    font-size: 14px;
    color: #e0e0e0;

    b {
      color: $--base-color;
    }
  }
}

.bind-creative {
  &__header {
    margin-bottom: 12px;
    font-size: 14px;
    color: #e0e0e0;

    b {
      color: $--base-color;
    }
  }

  &__search {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  &__pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }
}
</style>
